<template>
    <b-container fluid="">
        <button v-if="modulo == 'lista_usuarios'" :disabled="btn_crear" type="button"
            id="btn_flotante_agregar_informacion" class="btn btn-sm btn-outline-dark"
            @click="set_modulo('crear_usuario')"><i class="fas fa-plus"></i>
            Crear</button>
        <CrearUsuario v-if="modulo == 'crear_usuario'" v-on:actualizar_modulo="set_modulo('lista_usuarios')" />
        <ListaUsuarios v-if="modulo == 'lista_usuarios'" v-on:set_abrir_edicion="set_modulo('editar_usuario')" />
        <EditarUsuarios v-if="modulo == 'editar_usuario'" v-on:actualizar_modulo="set_modulo('lista_usuarios')" />
    </b-container>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import CrearUsuario from './Usuarios/Crear.vue'
    import ListaUsuarios from './Usuarios/Lista.vue'
    import EditarUsuarios from './Usuarios/Editar.vue'

    export default {
        name: 'Informacion',
        components: {
            CrearUsuario,
            ListaUsuarios,
            EditarUsuarios
        },
        computed: {
            ...mapState(['sucursal_seleccionada', 'permisos', 'datos_usuario']),
            ...mapGetters(['ES_ROOT'])
        },

        data() {
            return {
                modulo: 'lista_usuarios',
                btn_crear: true
            }
        },
        methods: {
            set_modulo(modulo) {
                this.modulo = modulo
            }
        },
        mounted() {
            if (this.ES_ROOT) {
                this.btn_crear = false
            } else {
                this.btn_crear = !this.permisos['sucursales.usuarios']?.crear
            }
        },
    }
</script>

<style>
    #btn_flotante_agregar_informacion {
        position: absolute;
        top: -20px;
        right: 30px;
        z-index: 999;
    }
</style>